/**
 * Internationalization Configuration
 * 
 * i18next setup for multi-language support throughout the application.
 * Configures language detection, translations, and fallback options.
 * 
 * Interactions:
 * - Uses i18next-browser-languagedetector for automatic language detection
 * - Imports translation JSON files for English and Spanish
 * - Configures namespace and resource structure for translations
 * - Used by withTranslation HOCs throughout component tree
 * - Enables dynamic language switching and content localization
 */

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: "en",
    fallbackLng: "en",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      es: {
        translations: translationEs,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;